import AutoplayController from "~/lib/autoplay_controller"
import { replay, tween } from "~/lib/motion"

// "Why not buy 2x?": one click swaps the item for the upgrade
export default class extends AutoplayController {
  static targets = ["quantity", "subtotal", "button"]

  reset() {
    this.quantityTarget.textContent = "1×"
    this.subtotalTarget.textContent = "$35.00"
    this.button.classList.remove("is-done")
    this.label.textContent = "Upgrade"
  }

  async play(wait) {
    await wait(1100)
    await this.click(this.button, wait)
    this.button.classList.add("is-done")
    this.label.textContent = "Upgraded"
    this.quantityTarget.textContent = "2×"
    replay(this.quantityTarget, "is-bump")
    tween(this.subtotalTarget, 35, 63)
  }

  get button() { return this.buttonTarget }
  get label() { return this.buttonTarget.querySelector("span") }
}
